import { css } from '@emotion/css';

export const z1301 = css`
  z-index: 1301;
`;
